// Ordinamento SOLO di visualizzazione per le liste di profili.
// Gruppi prioritari (nome base completo), poi tutti gli altri in ordine alfabetico.
const PRIORITY_BASES = ['elia bonacci', 'moreno bonacci', 'manuel bonacci'];

export const splitProfileName = (name) => {
  const clean = (name || '').trim().replace(/\s+/g, ' ');
  const m = clean.match(/^(.*?)\s+(\d+)$/);
  return m ? { base: m[1], num: parseInt(m[2], 10) } : { base: clean, num: 1 };
};

export const compareProfilesForDisplay = (a, b) => {
  const pa = splitProfileName(a.name);
  const pb = splitProfileName(b.name);
  const ga = PRIORITY_BASES.indexOf(pa.base.toLowerCase());
  const gb = PRIORITY_BASES.indexOf(pb.base.toLowerCase());
  const ra = ga === -1 ? PRIORITY_BASES.length : ga;
  const rb = gb === -1 ? PRIORITY_BASES.length : gb;
  if (ra !== rb) return ra - rb;
  if (ra < PRIORITY_BASES.length) {
    if (pa.num !== pb.num) return pa.num - pb.num;
  } else {
    const c = (a.name || '').localeCompare(b.name || '', 'it', { sensitivity: 'base' });
    if (c !== 0) return c;
  }
  return String(a.id || '').localeCompare(String(b.id || ''));
};

export const sortProfilesForDisplay = (list) => [...(list || [])].sort(compareProfilesForDisplay);
